import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=29ae85c8&scoped=true&"
import script from "./Delete.vue?vue&type=script&lang=js&"
export * from "./Delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ae85c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29ae85c8')) {
      api.createRecord('29ae85c8', component.options)
    } else {
      api.reload('29ae85c8', component.options)
    }
    module.hot.accept("./Delete.vue?vue&type=template&id=29ae85c8&scoped=true&", function () {
      api.rerender('29ae85c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/SecondaryUsers/Delete.vue"
export default component.exports